import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateLogEntryCache,
  LogEntryCacheEvents,
} from '@monorepo/shared/cacheRegisters/data2/logEntryCacheRegister';
import { setCache as setLogEntryCache } from '@monorepo/shared/hooks/logs/useLogEntry';
import { LogEntryResponse } from 'mapistry-shared';
import { MutationConfig, useMutation } from 'react-query';

type useLogEntryCreateParams = {
  config?: MutationConfig<LogEntryResponse, Api.ErrorResponse>;
};

export const useLogEntryCreate = (params?: useLogEntryCreateParams) =>
  useMutation(Api.createLogEntry, {
    ...params?.config,
    onSuccess: async (createdEntry, mutationFuncParams) => {
      const { organizationId, logId } = mutationFuncParams;

      // Set cache for that single log entry
      const keyParams = {
        organizationId,
        logId,
        logEntryId: createdEntry.id,
        projectId: createdEntry.projectId,
      };
      setLogEntryCache(keyParams, createdEntry);

      // Invalidate any cache that includes info about log entries
      invalidateLogEntryCache(LogEntryCacheEvents.CREATE, keyParams);

      return params?.config?.onSuccess?.(createdEntry, mutationFuncParams);
    },
  });
